import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Gamepad2, Trophy } from "lucide-react";

const SECTIONS = [
  { id: "introduction", label: "About" },
  { id: "habitat", label: "Habitat" },
  { id: "food", label: "Food" },
  { id: "body", label: "Body" },
  { id: "types", label: "Types" },
  { id: "vs-lion", label: "vs Lion" },
  { id: "endangered", label: "Endangered" },
  { id: "help", label: "Help" },
  { id: "fun-facts", label: "Quiz" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === "/";

  const handleScroll = (id) => {
    setOpen(false);
    if (!onHome) {
      window.location.href = `/#${id}`;
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="sticky top-0 z-50 w-full" data-testid="site-navbar">
      <div className="absolute inset-x-0 top-0 h-full bg-tiger-sand/90 backdrop-blur-md border-b-[3px] border-tiger-deep" />
      <div className="relative mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 sm:py-4">
        <Link
          to="/"
          className="flex items-center gap-2 group"
          data-testid="nav-logo"
        >
          <span className="grid h-11 w-11 place-items-center rounded-2xl border-[3px] border-tiger-deep bg-tiger-orange shadow-sticker transition-transform group-hover:-translate-y-0.5">
            <span className="text-2xl">🐯</span>
          </span>
          <span className="font-heading text-2xl font-bold text-tiger-deep tracking-tight">
            Tigersforkids<span className="text-tiger-orange">.com</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {SECTIONS.map((s) => (
            <button
              key={s.id}
              onClick={() => handleScroll(s.id)}
              className="rounded-full px-3 py-1.5 font-body font-bold text-sm text-tiger-deep hover:bg-tiger-cream transition-colors"
              data-testid={`nav-${s.id}`}
            >
              {s.label}
            </button>
          ))}
          <Link
            to="/leaderboard"
            className="ml-2 inline-flex items-center gap-2 rounded-full border-[3px] border-tiger-deep bg-white px-4 py-2 font-heading text-base font-bold text-tiger-deep shadow-sticker transition-transform hover:-translate-y-0.5 hover:shadow-stickerLg"
            data-testid="nav-leaderboard"
          >
            <Trophy className="h-5 w-5 text-tiger-orange" /> Leaderboard
          </Link>
          <Link
            to="/game"
            className="ml-2 inline-flex items-center gap-2 rounded-full border-[3px] border-tiger-deep bg-tiger-orange px-5 py-2 font-heading text-base font-bold text-white shadow-sticker transition-transform hover:-translate-y-0.5 hover:shadow-stickerLg"
            data-testid="nav-play-game"
          >
            <Gamepad2 className="h-5 w-5" /> Play Game!
          </Link>
        </nav>

        <button
          className="lg:hidden grid h-11 w-11 place-items-center rounded-2xl border-[3px] border-tiger-deep bg-white shadow-sticker"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden relative border-t-[3px] border-tiger-deep bg-tiger-sand">
          <div className="flex flex-col gap-1 px-4 py-3">
            {SECTIONS.map((s) => (
              <button
                key={s.id}
                onClick={() => handleScroll(s.id)}
                className="rounded-xl px-3 py-2 text-left font-body font-bold text-tiger-deep hover:bg-tiger-cream"
                data-testid={`nav-mobile-${s.id}`}
              >
                {s.label}
              </button>
            ))}
            <Link
              to="/leaderboard"
              className="mt-1 inline-flex items-center justify-center gap-2 rounded-full border-[3px] border-tiger-deep bg-white px-5 py-2.5 font-heading font-bold text-tiger-deep shadow-sticker"
              data-testid="nav-mobile-leaderboard"
            >
              <Trophy className="h-5 w-5 text-tiger-orange" /> Leaderboard
            </Link>
            <Link
              to="/game"
              className="mt-1 inline-flex items-center justify-center gap-2 rounded-full border-[3px] border-tiger-deep bg-tiger-orange px-5 py-2.5 font-heading font-bold text-white shadow-sticker"
              data-testid="nav-mobile-play-game"
            >
              <Gamepad2 className="h-5 w-5" /> Play Game!
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
